import { Base } from '@core/base/base'
import { AUTH_CONFIG } from './auth.service.config'

export const AuthService = new (class AuthService extends Base {
    constructor() {
        super('auth.service')
    }

    private async getQS() {
        const qs: string = (await this.storage.getItem('qs')) as string
        return new URLSearchParams(qs || '').toString()
    }

    async login() {
        const history =
            location.pathname.indexOf('/login') === -1 ? location.pathname : '/'
        const qsURL = await this.getQS()
        const search = new URLSearchParams({
            app_id: AUTH_CONFIG.app_id,
            audience_api: AUTH_CONFIG.audience_api,
            return_endpoint: `${
                AUTH_CONFIG.return_endpoint
            }${history}?auth=true${qsURL ? '&' + qsURL : ''}`,
        })

        location.href = `${AUTH_CONFIG.api_url}/login?${search.toString()}`
    }

    async logout() {
        const qsURL = await this.getQS()
        const search = new URLSearchParams({
            app_id: AUTH_CONFIG.app_id,
            returnTo: `${AUTH_CONFIG.return_endpoint}/login${
                qsURL ? '?' + qsURL : ''
            }`,
        })

        location.href = `${AUTH_CONFIG.api_url}/logout?${search.toString()}`
    }

    async refresh() {
        const qsURL = await this.getQS()
        const search = new URLSearchParams({
            app_id: AUTH_CONFIG.app_id,
            audience_api: AUTH_CONFIG.audience_api,
            return_endpoint: `${location.href}?auth=true${
                qsURL ? '&' + qsURL : ''
            }`,
        })

        location.href = `${AUTH_CONFIG.api_url}/login?${search.toString()}`
    }
})()
